export const MinusIcon = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3 8.5L13 8.5" stroke="#115C36" strokeWidth="2" />
  </svg>
);
